module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-solutions-for-any-device.de@2x-9d8b0c7225707858ae4620f0446b89a8.png";